<script setup lang="ts">
const code = useRouteParams<string | null>('code', null, { route: useRoute(), router: useRouter() })
const { LocalConfigurationStore } = stores()
const wideBanner = computed(() => !!LocalConfigurationStore.value?.siteInfo?.banner.wide)
</script>

<template>
  <NuxtLayout>
    <template
      v-if="wideBanner"
      #noLayout
    >
      <ContentBanner />
    </template>
    <ContentBanner v-if="!wideBanner" />

    <ContentProductList :initial-product="code" />
    <ContentHighlights />
    <ContentCompanyList />
  </NuxtLayout>
</template>
